import { render, staticRenderFns } from "./CBProposalOutdoorRisk.vue?vue&type=template&id=1e59acb9"
import script from "./CBProposalOutdoorRisk.vue?vue&type=script&lang=js"
export * from "./CBProposalOutdoorRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports